<header
  [class.absolute]="positionAbsoluteOnMobile"
  [class.pt-8]="isNotched"
  [ngClass]="positionAbsoluteOnDesktop ? 'md:absolute' : 'md:relative'"
  class="mx-auto z-30 w-full"
>
  <div
    class="flex justify-between py-4 px-5 lg:px-12 overflow-x-auto w-full items-center scrollbar-hide"
    [style.backgroundColor]="backgroundColor | contentBuilderColor"
  >
    <div class="flex justify-start items-center md:overflow-x-auto flex-shrink scrollbar-hide">
      <a
        [link]="'/'"
        *ngIf="displayLogo"
      >
        <img
          class="h-12 max-w-none"
          src="{{ logoImageUrl }}"
          alt=""
        />
      </a>
      <app-rounded-icon-button
        *ngIf="displayBackButton"
        [icon]="'icon-arrow-left'"
        [type]="'light'"
        [size]="isNotched ? 'isNotched' : 'md'"
        [color]="'neutral'"
        [overrideBackgroundColor]="iconBackgroundColor"
        [overrideColor]="iconColor"
        (click)="back()"
      ></app-rounded-icon-button>
      <div class="ml-2 mr-4 flex flew-row flex-shrink items-center">
        <app-block-list [blockIdList]="leftBlocks"></app-block-list>
        <app-block-list
          [blockIdList]="navigationLinks"
          *ngIf="navigationLinks && !isMobileScreenType"
        ></app-block-list>
      </div>
    </div>

    <h1
      *ngIf="title$ | async as title"
      class="block lg:hidden font-accent font-bold text-md text-center"
    >
      {{ title | translate }}
    </h1>

    <div class="flex flex-row items-center justify-end flex-shrink-0 -mr-4">
      <!-- Shop search address -->
      <div
        class="hidden lg:block rounded-full mr-4 mix-blend-multiply w-96"
        *ngIf="isShopSearchAddressVisible$ | async"
      >
        <app-shop-search-location-input></app-shop-search-location-input>
      </div>

      <!-- Shop search parameters -->
      <div
        class="hidden lg:block rounded-full mr-4"
        *ngIf="isShopSearchParametersVisible$ | async"
      >
        <app-shop-search-parameters-overview
          [iconBackgroundColor]="iconBackgroundColor"
          [iconColor]="iconColor"
          [textColor]="labelColor"
        ></app-shop-search-parameters-overview>
      </div>

      <!-- Cart parameters -->
      <div
        class="hidden lg:block rounded-full mr-4"
        *ngIf="isCartParametersVisible$ | async"
      >
        <app-cart-parameters-overview
          [iconBackgroundColor]="iconBackgroundColor"
          [iconColor]="iconColor"
          [textColor]="labelColor"
        ></app-cart-parameters-overview>
      </div>

      <!-- Cart button -->
      <div
        class="hidden lg:block rounded-full mr-4"
        *ngIf="isCartButtonVisible$ | async"
      >
        <app-button-atom
          [size]="'L'"
          [type]="'primary'"
          [disabled]="isNavigationToCartInProgress"
          [icon]="!isNavigationToCartInProgress ? 'icon-shopping-bag' : undefined"
          [iconUrl]="isNavigationToCartInProgress ? 'assets/images/spinner.svg' : undefined"
          [label]="('shop-page.basket' | translate) + ' (' + (cartProducts$ | async)?.length + ')'"
          [overrideBgColor]="buttonBackgroundColor"
          [overrideTextColor]="buttonTextColor"
          (click)="navigateToCart()"
        ></app-button-atom>
      </div>

      <div
        class="flex ml-5 mr-4"
        *ngIf="displayHamburger"
      >
        <div class="flex items-center flew-row flex-shrink">
          <app-block-list [blockIdList]="rightBlocks"></app-block-list>
        </div>
        <app-header-language-flag-atom
          *ngIf="languageFlagUrl"
          [languageFlagUrl]="languageFlagUrl"
          (click)="onLanguageFlagClick()"
        ></app-header-language-flag-atom>
        <div class="flex items-center">
          <app-hamburger-menu-atom
            [color]="hamburgerColor"
            [class.md:hidden]="navigationLinks?.length"
            [light]="positionAbsoluteOnMobile && isMobileScreenType"
            (click)="navigationLinks?.length ? toggleStaticNav() : onClick()"
          ></app-hamburger-menu-atom>
        </div>
      </div>
    </div>
  </div>
</header>
<nav
  class="z-100 w-screen bg-neutral-800"
  [ngClass]="isOpenStaticNav ? 'fixed top-0 bottom-0 left-0 right-0' : 'hidden'"
>
  <div class="flex flex-col justify-center h-screen text-center">
    <header class="absolute w-full top-0 p-5">
      <div class="flex justify-between">
        <span></span>
        <span
          ><i
            class="icon icon-cross text-white"
            (click)="toggleStaticNav()"
          ></i
        ></span>
      </div>
    </header>
    <div class="self-center">
      <app-block-list
        *ngIf="navigationLinks"
        class="overflow-x-scroll bg-white"
        [blockIdList]="navigationLinks"
        (click)="toggleStaticNav()"
      ></app-block-list>
      <app-block-list [blockIdList]="rightBlocks"></app-block-list>
    </div>
  </div>
</nav>
